
import axios from "axios";

const instance = axios.create({
     baseURL: 'https://server.portfolio-adilzhexenov.kz'//'http://localhost:4000'//
});

export default instance;
